import { motion } from "framer-motion";
import { useAbVariant } from "@/hooks/useAbVariant";

const ease = [0.16, 1, 0.3, 1];

export default function Pricing() {
  const { copy, variant } = useAbVariant();
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="px-6 md:px-12 lg:px-24 py-20 md:py-28 bg-secondary"
    >
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
          className="md:col-span-5"
        >
          <h2 className="font-serif-display tracking-tight leading-[0.98] text-3xl sm:text-4xl md:text-5xl">
            And, should you wish to
            <br /> book us afterwards…
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease, delay: 0.1 }}
          className="md:col-span-7"
        >
          <ul className="divide-y divide-border border-t border-b border-border">
            <li
              data-testid="pricing-tier-photography"
              className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between py-5 sm:py-6 gap-1 sm:gap-4"
            >
              <span className="font-serif-display text-2xl md:text-3xl tracking-tight">
                Photography
              </span>
              <span className="font-serif-display italic text-lg md:text-2xl text-foreground/70">
                from £3,000
              </span>
            </li>
            <li
              data-testid="pricing-tier-photography-and-film"
              className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between py-5 sm:py-6 gap-1 sm:gap-4"
            >
              <span className="font-serif-display text-2xl md:text-3xl tracking-tight">
                Photography &amp; Film
              </span>
              <span className="font-serif-display italic text-lg md:text-2xl text-foreground/70">
                from £4,000
              </span>
            </li>
          </ul>
          <p className="mt-6 text-sm text-foreground/65 leading-relaxed max-w-lg">
            No obligation, no pressure. Tailored during your consultation.
          </p>
          <a
            href="#apply"
            data-testid="pricing-cta"
            data-cta-variant={variant}
            className="mt-8 inline-flex items-center gap-3 eyebrow pb-1 border-b border-foreground hover:opacity-70 transition-opacity"
          >
            {copy.full} →
          </a>
        </motion.div>
      </div>
    </section>
  );
}
